var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNav2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    role: "img",
    viewBox: "0 0 100 100",
    fill: "#70757D",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 9.43a.92.92 0 0 1-.36-.07L16 4.07 2.36 9.36a1 1 0 0 1-1.29-.57.99.99 0 0 1 .57-1.29l13.64-5.29c.46-.18.98-.18 1.45 0L30.36 7.5A1 1 0 0 1 30 9.43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30a.98.98 0 0 1-.41-.09l-6.24-2.77a1 1 0 0 1-.51-1.32 1 1 0 0 1 1.32-.51l5.84 2.6 13-5.77V9.92L16.38 15.1a1 1 0 0 1-.76 0L3 9.92v12.22l2.93 1.3a1 1 0 0 1 .51 1.32 1 1 0 0 1-1.32.51L1.59 23.7a1 1 0 0 1-.59-.91V8.43a1 1 0 0 1 .44-.83c.28-.19.63-.22.94-.1L16 13.09 29.62 7.5c.31-.13.66-.09.94.09.27.19.44.5.44.84v14.36c0 .4-.23.75-.59.91l-14 6.21A.98.98 0 0 1 16 30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.53a1 1 0 0 1-1-1V14.17c0-.55.45-1 1-1s1 .45 1 1v14.36a1 1 0 0 1-1 1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.54 19.48a1 1 0 0 1-1-1v-6.49L8.83 6.85a1 1 0 0 1 .7-1.88l14.36 5.38a1 1 0 0 1 .65.94v7.18a1 1 0 0 1-1 1.01z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNav2);
export default __webpack_public_path__ + "static/media/iconNav2.b5961e85a1f6de601280bccf3f4edcab.svg";
export { ForwardRef as ReactComponent };